/**
 * The element a Compact Pricing slot renders as, shared by every variant.
 *
 * A slot is a control only when it navigates: an `<a>` when the editor filled
 * in `ctaUrl`, a plain `<div>` otherwise. Either way the card's event tracking
 * fires on click.
 *
 * The `<div>` carries the handler rather than being a `<button>` (as it was
 * between MR !835 and this one) because it performs no action: a button put
 * the whole slot in the tab order, announced it as a control and gave it a
 * pointer cursor, all for something that did nothing when triggered. On
 * campaign variant C the slot *is* the card, so the page shipped one
 * page-wide button wrapping the image, the headline and the price. Reporting
 * a click needs no control, only a click.
 */
export function PricingSlot({
  ctaUrl,
  onClick,
  className,
  children,
}: {
  ctaUrl?: string | undefined;
  onClick?: (() => void) | undefined;
  className: string;
  children: React.ReactNode;
}) {
  if (ctaUrl) {
    return (
      <a href={ctaUrl} onClick={onClick} className={className}>
        {children}
      </a>
    );
  }

  return (
    <div onClick={onClick} className={className}>
      {children}
    </div>
  );
}
